export class TriggerDefParam {
    public TriggerDefinitionId: number;
    public TriggerDefParamName: string;
    public TriggerDefParamDesc: string;
}
